import { IFormValidationRules } from './form-validation-rules';

export type IFormValidationDefinition<T> = {
  fields: IFormValidationRules<T>;
  additional?: (value: T) => boolean;
};
